
  import { Component, Prop } from 'vue-property-decorator'
  import { GForm } from '@/components/forms/GForm'

@Component
  export default class FormStepper extends GForm {
  @Prop({ type: [String, Number, Object, Array] }) value!: any
  @Prop({ type: String, default: '' }) title!: string

  panel = -1

  /**
   * Devuelve el ícono según el estado del paso
   */
  getIcon (val: boolean | null | undefined) {
    if (val === true) return 'mdi-check-circle' // Completado
    if (val === false) return 'mdi-alert-circle' // Por corrección
    return 'mdi-alert-circle-outline' // Pendiente
  }

  /**
   * Devuelve el color del ícono según el estado del paso
   */
  getColor (val: boolean | null | undefined) {
    if (val === true) return 'green' // Completado
    if (val === false) return 'red' // Por corrección
    return 'orange' // Pendiente
  }

  /**
   * Devuelve la leyenda del tooltip según el estado del paso
   */
  getTooltipText (val: boolean | null | undefined): string {
    if (val === true) return 'Ok'
    if (val === false) return 'Por corrección'
    return 'Pendiente'
  }

  isLink (link) {
    if (!link) return false

    if (typeof link === 'string') return true

    if (Array.isArray(link) && link.length) return true
  }

  /**
   * Devuelve true si todas las validaciones están completas
   */
  get allTrue () {
    return this.validations.every(val => val.value === true)
  }

  /**
   * Obtiene la lista de validaciones desde las props
   */
  get validations () {
    if (!this.value?.length) return []
    return this.value
  }
  }
